<template>
  <div></div>
</template>

<script>
import JsPDF from 'jspdf'
import html2canvas from "html2canvas";
export default {
  name: "ExportPdf",
  install (Vue, options) {
    Vue.prototype.exportPdf = function (id,title) {
      const scale = 2

      // 滚动到顶部，避免打印不全
      // document.documentElement.scrollTop = 0

      html2canvas(document.querySelector(`#${id}`), {
        allowTaint: true, // Whether to allow cross-origin images to taint the canvas
        scale // The scale to use for rendering. Defaults to the browsers device pixel ratio.
      }).then((canvas) => {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        // 单页
        console.log(contentWidth, 'contentWidth')
        console.log(contentHeight, 'contentHeight')

        // jspdf.js 插件对单页面的最大宽高限制 为 14400
        let limit = 14400
        let pageData = canvas.toDataURL('image/jpeg', 1.0)

        if (contentHeight > limit) {
          let contentScale = limit / contentHeight
          contentHeight = limit
          contentWidth = contentScale * contentWidth
        }

        let orientation = 'p'
        // 在 jspdf 源码里，如果是 orientation = 'p' 且 width > height 时， 会把 width 和 height 值交换，
        // 类似于 把 orientation 的值修改为 'l' , 反之亦同。
        if (contentWidth > contentHeight) {
          orientation = 'l'
        }

        // orientation Possible values are "portrait" or "landscape" (or shortcuts "p" or "l")
        let pdf = new JsPDF(orientation, 'pt', [contentWidth, contentHeight]) // 下载尺寸 a4 纸 比例

        // pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置
        pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight)
        pdf.save(title + '.pdf')
      })
    },
    Vue.prototype.exportPdfPage = function (id,title) {
      html2canvas(document.querySelector(`#${id}`), {
        allowTaint: true
        // useCORS:true)
      }).then(function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28
          let imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
        }
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myComponents/ExportPdf.vue